import { j as s } from "./atoms-v218.js";
import { Text as m } from "./atoms-v2745.js";
import { SkeletonRow as x } from "./atoms-v2778.js";
const l = ({
  skeletonLineCount: e,
  skeletonLineHeight: o = 11,
  skeletonLineWidth: r = "100%"
}) => {
  const t = e || 2;
  return Array.from(Array(t).keys()).map((i) => {
    const a = i < t - 1 || t === 1 ? r : "60%";
    return /* @__PURE__ */ s.jsx(x, { height: o, width: a }, i);
  });
}, p = ({
  ariaLabel: e,
  className: o,
  skeletonLineCount: r,
  skeletonLineHeight: t = 11,
  skeletonLineWidth: n = "100%"
}) => /* @__PURE__ */ s.jsx(
  m,
  {
    $isSkeleton: !0,
    "aria-hidden": "true",
    "aria-label": e,
    className: o,
    "data-testid": "text-skeleton",
    children: /* @__PURE__ */ s.jsx(
      l,
      {
        skeletonLineCount: r,
        skeletonLineHeight: t,
        skeletonLineWidth: n
      }
    )
  }
);
export {
  p as TextSkeleton
};
